import { TagTooltip } from 'common/models/tag.model';

export const TAG_TOOLTIP_MAP: TagTooltip = {
  ['Disease State']: 'Condition',
  ['Topic']: 'Medical Concept',
};
